var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "contacts" },
      [
        _c("h1", { staticClass: "contacts-title" }, [
          _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
        ]),
        _c("div", {
          staticClass: "contacts-card-content",
          domProps: { innerHTML: _vm._s(_vm.PAGE_CONTENT) }
        }),
        _c("h4", [_vm._v("Мы в соцсетях")]),
        _c("social-networks", { staticClass: "contacts__social-networks" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }